import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import Container from 'gatsby-theme-core/src/components/container';
import Section from 'gatsby-theme-pdv/src/components/section';
import { CtaOutboundLink } from 'gatsby-theme-pdv/src/components/cta';

const OldPrice = styled.span`
  text-decoration: line-through;
  padding-right: .5rem;
  color: ${({ theme }) => theme.gray3};
`;
const PriceWrapper = styled.h3`
  display: block;
  margin: 0;
  padding: .5rem 0;
  color: ${({ theme }) => theme.primaryColor};
`;
const Title = styled.h2`
  margin: 0;
  overflow: hidden;
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-line-clamp: 3;
   -webkit-box-orient: vertical;
`;
const ItemImageWrapper = styled.div`
  margin-left: -${(props) => props.theme.grid.gap};
  margin-right: -${(props) => props.theme.grid.gap};
  @media all and (min-width: ${(props) => props.theme.breakingpoints.sm}) {
    margin-left: 0;
    margin-right: 0;
  }
`;
const ItemContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const Item = styled.article`
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;
  grid-gap: ${(props) => props.theme.grid.gap};
  @media all and (min-width: ${(props) => props.theme.breakingpoints.sm}) {
    grid-template-columns: 1fr 1fr;
  }
`;
const Wrapper = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;
  grid-gap: 2rem ${(props) => props.theme.grid.gap};
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    grid-gap: 2rem;
    grid-template-columns: 1fr 1fr;
  }
`;

const priceFormat = (price) => {
  if (price === null) {
    return '€0,-';
  }
  return price?.replace('.00', ',-');
};

const WooCommerceProducts = ({ className, rowOptions, category }) => {
  const { products } = useStaticQuery(graphql`
    query PdVAllWooProductsQuery {
      products: allWpSimpleProduct(
        filter: { status: { eq: "publish" } }
        sort: { menuOrder: ASC }
      ) {
        nodes {
          name
          id
          productCategories {
            nodes {
              name
            }
          }
          ... on WpSimpleProduct {
            uri
            price
            salePrice
            regularPrice
          }
          image {
            filename
            altText
            gatsbyImage(
              layout: CONSTRAINED
              placeholder: BLURRED
              width: 600
              height: 600
              cropFocus: CENTER
            )
          }
        }
      }
    }
  `);

  const items = category
    ? products.nodes.filter(({
      productCategories,
    }) => productCategories.nodes.some(({ name }) => name === category))
    : products.nodes;

  return (
    <Section
      className={className}
      id={rowOptions?.sectionId || ''}
      backgroundColor={rowOptions?.backgroundColor}
      hideBottomSpacing={rowOptions?.hideBottomSpacing}
      hideTopSpacing={rowOptions?.hideTopSpacing}
      hideRow={rowOptions?.hideRow}
    >
      <Container small>
        <Wrapper>
          {items && items.map((item) => (
            <Item key={item.id}>
              <ItemImageWrapper>
                {item?.image && (
                  <Image
                    image={item.image}
                    fallbackAlt={item.name}
                  />
                )}
              </ItemImageWrapper>
              <ItemContentWrapper>
                <div>
                  <Title>{item.name}</Title>
                </div>
                <div>
                  <PriceWrapper>
                    {item.salePrice && (
                      <>
                        <OldPrice>{priceFormat(item.regularPrice)}</OldPrice>
                        {priceFormat(item.salePrice)}
                      </>
                    )}
                    {!item.salePrice && (
                      <>
                        {priceFormat(item.price)}
                      </>
                    )}
                  </PriceWrapper>
                  <CtaOutboundLink
                    href={`https://shop.dcdw.nl${item.uri}`}
                    variant="primary"
                  >
                    Meer informatie
                  </CtaOutboundLink>
                </div>
              </ItemContentWrapper>
            </Item>
          ))}
        </Wrapper>
      </Container>
    </Section>
  );
};

export default WooCommerceProducts;
